
export class MachineNeedleMappingSharedDto {
    id: number;
    stylesId: string;
    machinesId: string;
    needleModelId: string;
    needlePointTypeId: string;
    needleSizesId: string;
    createdUser: string;
    isActive?: boolean
    versionFlag?: number;
    updatedUser?: string;
    updatedAt?: Date;

    constructor(
        id: number,
        stylesId: string,
        machinesId: string,
        needleModelId: string,
        needlePointTypeId: string,
        needleSizesId: string,
        createdUser: string,
        isActive?: boolean,
        versionFlag?: number,
        updatedUser?: string,
        updatedAt?: Date
    ) {
        this.id = id;
        this.stylesId = stylesId;
        this.machinesId = machinesId;
        this.needleModelId = needleModelId;
        this.needlePointTypeId = needlePointTypeId;
        this.needleSizesId = needleSizesId;
        this.createdUser = createdUser;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
        this.updatedUser = updatedUser;
        this.updatedAt = updatedAt;

    }
}

export class MachineNeedleMappingIdDto {
    id: number;
    isActive?: boolean
    versionFlag?: number;

    constructor(
        id: number,
        isActive?: boolean,
        versionFlag?: number,

    ) {
        this.id = id;
        this.isActive = isActive;
        this.versionFlag = versionFlag;
    }
}


